// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StructureMapFlowEditor_editor__eozFU {
  display: grid;
  gap: 0.75rem;
}
.StructureMapFlowEditor_toolbar__eNRQt {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}
.StructureMapFlowEditor_toolbar__eNRQt select {
  max-width: 16rem;
}
.StructureMapFlowEditor_toolbar__eNRQt span {
  color: #596b7c;
  font-size: 0.85rem;
}
.StructureMapFlowEditor_workspace__WZGHm {
  display: grid;
  grid-template-columns: minmax(220px, 280px) minmax(0, 1fr);
  height: 74vh;
  min-height: 650px;
}
.StructureMapFlowEditor_ruleTree__rrTha {
  background: #f5f8fa;
  border: 1px solid #ced9e4;
  border-right: 0;
  border-radius: 0.45rem 0 0 0.45rem;
  overflow: auto;
  padding: 0.55rem;
}
.StructureMapFlowEditor_treeHeading__3dKR4 {
  color: #35536a;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 0.4rem 0.55rem 0.65rem;
  text-transform: uppercase;
}
.StructureMapFlowEditor_treeSearch__91Yy5 {
  margin: 0 0.1rem 0.45rem;
  width: calc(100% - 0.2rem);
}
.StructureMapFlowEditor_treeActions__YN9Fx {
  display: flex;
  gap: 0.35rem;
  margin: 0 0.1rem 0.55rem;
}
.StructureMapFlowEditor_treeActions__YN9Fx button {
  background: transparent;
  border: 0;
  color: #315d79;
  font-size: 0.7rem;
  padding: 0.15rem 0.25rem;
  text-decoration: underline;
}
.StructureMapFlowEditor_treeActions__YN9Fx button:hover {
  color: #124d57;
}
.StructureMapFlowEditor_treeItem__MNMXm,
.StructureMapFlowEditor_activeTreeItem__uM9r9 {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 0.3rem;
  color: #36556b;
  display: flex;
  font-size: 0.8rem;
  gap: 0.35rem;
  margin: 0.1rem 0;
  min-height: 2.35rem;
  padding: 0.45rem 0.55rem;
  text-align: left;
  width: 100%;
}
.StructureMapFlowEditor_treeItem__MNMXm:hover {
  background: #e5eef3;
}
.StructureMapFlowEditor_activeTreeItem__uM9r9 {
  background: #d9edf0;
  box-shadow: inset 3px 0 #187985;
  color: #124d57;
  font-weight: 700;
}
.StructureMapFlowEditor_treeLabel__7E81Q {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.StructureMapFlowEditor_treeCount__c20on {
  background: #e4ebef;
  border-radius: 1rem;
  color: #617382;
  font-size: 0.68rem;
  padding: 0.08rem 0.35rem;
}
.StructureMapFlowEditor_treeCollapseAction__eMZj2 {
  color: #315d79;
  font-size: 0.68rem;
  font-weight: 600;
  padding: 0.16rem 0.22rem;
  text-decoration: underline;
  white-space: nowrap;
}
.StructureMapFlowEditor_canvas__3fE4K {
  background: #f8fafc;
  border: 1px solid #ced9e4;
  border-radius: 0 0.45rem 0.45rem 0;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
.StructureMapFlowEditor_mappingBox__CYq\\+i {
  background: white;
  border: 2px solid #557894;
  border-radius: 0.55rem;
  box-shadow: 0 3px 12px rgb(34 61 84 / 14%);
  min-width: 365px;
  overflow: hidden;
}
.StructureMapFlowEditor_sourceBox__HA-5y {
  border-color: #187985;
}
.StructureMapFlowEditor_targetBox__rTVBQ {
  border-color: #87549a;
}
.StructureMapFlowEditor_boxHeading__CBsia {
  align-items: baseline;
  background: #eef5f8;
  display: flex;
  gap: 0.6rem;
  justify-content: space-between;
  padding: 0.55rem 0.75rem;
}
.StructureMapFlowEditor_targetBox__rTVBQ .StructureMapFlowEditor_boxHeading__CBsia {
  background: #f7f0f9;
}
.StructureMapFlowEditor_boxHeading__CBsia strong {
  font-size: 1rem;
}
.StructureMapFlowEditor_boxHeading__CBsia span {
  color: #526473;
  font-size: 0.78rem;
}
.StructureMapFlowEditor_contexts__\\+a4lL {
  border-bottom: 1px solid #dce5ea;
  color: #4c6170;
  font-size: 0.75rem;
  padding: 0.35rem 0.75rem;
}
.StructureMapFlowEditor_empty__KnUjF {
  color: #718394;
  font-size: 0.83rem;
  font-style: italic;
  padding: 1.2rem 0.75rem;
}
.StructureMapFlowEditor_elementRow__D0qDQ {
  background: #fff;
  border-bottom: 1px solid #e1e8ed;
  display: grid;
  gap: 0.38rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 0.65rem 0.75rem;
  position: relative;
}
.StructureMapFlowEditor_elementRow__D0qDQ:nth-child(odd) {
  background: #fbfdfe;
}
.StructureMapFlowEditor_elementRow__D0qDQ:last-child {
  border-bottom: 0;
}
.StructureMapFlowEditor_rowTitle__Gzu0u {
  align-items: center;
  color: #315d79;
  display: flex;
  font-size: 0.72rem;
  font-weight: 700;
  gap: 0.35rem;
  grid-column: 1 / -1;
  min-width: 0;
}
.StructureMapFlowEditor_rowTitle__Gzu0u span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.StructureMapFlowEditor_rowTitle__Gzu0u small {
  color: #758793;
  font-size: 0.64rem;
  font-weight: 600;
  margin-left: auto;
  text-transform: uppercase;
}
.StructureMapFlowEditor_deleteRuleButton__enPHU,
.StructureMapFlowEditor_deleteTransformButton__CkEaY {
  align-items: center;
  background: #fff;
  border: 1px solid #d59494;
  border-radius: 50%;
  color: #b3261e;
  display: inline-flex;
  font-size: 0.9rem;
  font-weight: 700;
  height: 1.2rem;
  justify-content: center;
  line-height: 1;
  padding: 0;
  width: 1.2rem;
}
.StructureMapFlowEditor_deleteRuleButton__enPHU:hover,
.StructureMapFlowEditor_deleteTransformButton__CkEaY:hover {
  background: #fdecec;
}
.StructureMapFlowEditor_deleteTransformButton__CkEaY {
  position: absolute;
  right: 0.35rem;
  top: 0.35rem;
}
.StructureMapFlowEditor_rowActions__KUz1v {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  grid-column: 1 / -1;
}
.StructureMapFlowEditor_rowActions__KUz1v button {
  background: #eff6f8;
  border: 1px solid #9dbbc4;
  border-radius: 0.25rem;
  color: #245c68;
  font-size: 0.68rem;
  font-weight: 600;
  padding: 0.25rem 0.4rem;
}
.StructureMapFlowEditor_rowActions__KUz1v button:hover {
  background: #d9edf0;
}
.StructureMapFlowEditor_flowToggle__nfzvE {
  background: #e8f0f5;
  border: 1px solid #9db4c5;
  border-radius: 0.2rem;
  color: #315d79;
  font-weight: 700;
  height: 1.25rem;
  line-height: 1;
  padding: 0;
  width: 1.25rem;
}
.StructureMapFlowEditor_elementRow__D0qDQ label,
.StructureMapFlowEditor_transformNode__2FOjf label {
  color: #435466;
  display: grid;
  font-size: 0.67rem;
  font-weight: 600;
  gap: 0.12rem;
}
.StructureMapFlowEditor_elementRow__D0qDQ input,
.StructureMapFlowEditor_elementRow__D0qDQ select,
.StructureMapFlowEditor_transformNode__2FOjf input,
.StructureMapFlowEditor_transformNode__2FOjf select {
  border: 1px solid #b9c7d4;
  border-radius: 0.2rem;
  font-size: 0.75rem;
  min-width: 0;
  padding: 0.23rem 0.3rem;
  width: 100%;
}
.StructureMapFlowEditor_rowHandle__dhmag,
.StructureMapFlowEditor_transformHandle__Zxy6X {
  height: 0.72rem;
  width: 0.72rem;
}
.StructureMapFlowEditor_transformNode__2FOjf {
  background: #fffaf0;
  border: 2px solid #d69127;
  border-radius: 0.5rem;
  box-shadow: 0 3px 12px rgb(95 67 25 / 14%);
  display: grid;
  gap: 0.35rem;
  min-width: 180px;
  padding: 0.55rem 0.65rem;
  position: relative;
}
.StructureMapFlowEditor_parameterRow__gxcil {
  display: grid;
  gap: 0.35rem;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
}
.StructureMapFlowEditor_parameterRowEmpty__Orbm1 {
  grid-template-columns: minmax(0, 0.8fr);
}
.StructureMapFlowEditor_transformTitle__4wVxe {
  color: #82520f;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
}
@media (max-width: 767px) {
  .StructureMapFlowEditor_workspace__WZGHm {
    grid-template-columns: 1fr;
    height: auto;
    min-height: 0;
  }
  .StructureMapFlowEditor_ruleTree__rrTha {
    border: 1px solid #ced9e4;
    border-radius: 0.45rem 0.45rem 0 0;
    max-height: 200px;
  }
  .StructureMapFlowEditor_canvas__3fE4K {
    border-radius: 0 0 0.45rem 0.45rem;
    height: 66vh;
    min-height: 500px;
  }
  .StructureMapFlowEditor_mappingBox__CYq\\+i {
    min-width: 330px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StructureMapFlowEditor/StructureMapFlowEditor.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,0DAA0D;EAC1D,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,gDAAgD;EAChD,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,aAAa;AACf;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,UAAU;EACV,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;;;;EAIE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ,wDAAwD;AAC1D;AACA;EACE,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,kCAAkC;IAClC,iBAAiB;EACnB;EACA;IACE,kCAAkC;IAClC,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".editor {\n  display: grid;\n  gap: 0.75rem;\n}\n.toolbar {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n}\n.toolbar select {\n  max-width: 16rem;\n}\n.toolbar span {\n  color: #596b7c;\n  font-size: 0.85rem;\n}\n.workspace {\n  display: grid;\n  grid-template-columns: minmax(220px, 280px) minmax(0, 1fr);\n  height: 74vh;\n  min-height: 650px;\n}\n.ruleTree {\n  background: #f5f8fa;\n  border: 1px solid #ced9e4;\n  border-right: 0;\n  border-radius: 0.45rem 0 0 0.45rem;\n  overflow: auto;\n  padding: 0.55rem;\n}\n.treeHeading {\n  color: #35536a;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  padding: 0.4rem 0.55rem 0.65rem;\n  text-transform: uppercase;\n}\n.treeSearch {\n  margin: 0 0.1rem 0.45rem;\n  width: calc(100% - 0.2rem);\n}\n.treeActions {\n  display: flex;\n  gap: 0.35rem;\n  margin: 0 0.1rem 0.55rem;\n}\n.treeActions button {\n  background: transparent;\n  border: 0;\n  color: #315d79;\n  font-size: 0.7rem;\n  padding: 0.15rem 0.25rem;\n  text-decoration: underline;\n}\n.treeActions button:hover {\n  color: #124d57;\n}\n.treeItem,\n.activeTreeItem {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 0.3rem;\n  color: #36556b;\n  display: flex;\n  font-size: 0.8rem;\n  gap: 0.35rem;\n  margin: 0.1rem 0;\n  min-height: 2.35rem;\n  padding: 0.45rem 0.55rem;\n  text-align: left;\n  width: 100%;\n}\n.treeItem:hover {\n  background: #e5eef3;\n}\n.activeTreeItem {\n  background: #d9edf0;\n  box-shadow: inset 3px 0 #187985;\n  color: #124d57;\n  font-weight: 700;\n}\n.treeLabel {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.treeCount {\n  background: #e4ebef;\n  border-radius: 1rem;\n  color: #617382;\n  font-size: 0.68rem;\n  padding: 0.08rem 0.35rem;\n}\n.treeCollapseAction {\n  color: #315d79;\n  font-size: 0.68rem;\n  font-weight: 600;\n  padding: 0.16rem 0.22rem;\n  text-decoration: underline;\n  white-space: nowrap;\n}\n.canvas {\n  background: #f8fafc;\n  border: 1px solid #ced9e4;\n  border-radius: 0 0.45rem 0.45rem 0;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n.mappingBox {\n  background: white;\n  border: 2px solid #557894;\n  border-radius: 0.55rem;\n  box-shadow: 0 3px 12px rgb(34 61 84 / 14%);\n  min-width: 365px;\n  overflow: hidden;\n}\n.sourceBox {\n  border-color: #187985;\n}\n.targetBox {\n  border-color: #87549a;\n}\n.boxHeading {\n  align-items: baseline;\n  background: #eef5f8;\n  display: flex;\n  gap: 0.6rem;\n  justify-content: space-between;\n  padding: 0.55rem 0.75rem;\n}\n.targetBox .boxHeading {\n  background: #f7f0f9;\n}\n.boxHeading strong {\n  font-size: 1rem;\n}\n.boxHeading span {\n  color: #526473;\n  font-size: 0.78rem;\n}\n.contexts {\n  border-bottom: 1px solid #dce5ea;\n  color: #4c6170;\n  font-size: 0.75rem;\n  padding: 0.35rem 0.75rem;\n}\n.empty {\n  color: #718394;\n  font-size: 0.83rem;\n  font-style: italic;\n  padding: 1.2rem 0.75rem;\n}\n.elementRow {\n  background: #fff;\n  border-bottom: 1px solid #e1e8ed;\n  display: grid;\n  gap: 0.38rem;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  padding: 0.65rem 0.75rem;\n  position: relative;\n}\n.elementRow:nth-child(odd) {\n  background: #fbfdfe;\n}\n.elementRow:last-child {\n  border-bottom: 0;\n}\n.rowTitle {\n  align-items: center;\n  color: #315d79;\n  display: flex;\n  font-size: 0.72rem;\n  font-weight: 700;\n  gap: 0.35rem;\n  grid-column: 1 / -1;\n  min-width: 0;\n}\n.rowTitle span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rowTitle small {\n  color: #758793;\n  font-size: 0.64rem;\n  font-weight: 600;\n  margin-left: auto;\n  text-transform: uppercase;\n}\n.deleteRuleButton,\n.deleteTransformButton {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #d59494;\n  border-radius: 50%;\n  color: #b3261e;\n  display: inline-flex;\n  font-size: 0.9rem;\n  font-weight: 700;\n  height: 1.2rem;\n  justify-content: center;\n  line-height: 1;\n  padding: 0;\n  width: 1.2rem;\n}\n.deleteRuleButton:hover,\n.deleteTransformButton:hover {\n  background: #fdecec;\n}\n.deleteTransformButton {\n  position: absolute;\n  right: 0.35rem;\n  top: 0.35rem;\n}\n.rowActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  grid-column: 1 / -1;\n}\n.rowActions button {\n  background: #eff6f8;\n  border: 1px solid #9dbbc4;\n  border-radius: 0.25rem;\n  color: #245c68;\n  font-size: 0.68rem;\n  font-weight: 600;\n  padding: 0.25rem 0.4rem;\n}\n.rowActions button:hover {\n  background: #d9edf0;\n}\n.flowToggle {\n  background: #e8f0f5;\n  border: 1px solid #9db4c5;\n  border-radius: 0.2rem;\n  color: #315d79;\n  font-weight: 700;\n  height: 1.25rem;\n  line-height: 1;\n  padding: 0;\n  width: 1.25rem;\n}\n.elementRow label,\n.transformNode label {\n  color: #435466;\n  display: grid;\n  font-size: 0.67rem;\n  font-weight: 600;\n  gap: 0.12rem;\n}\n.elementRow input,\n.elementRow select,\n.transformNode input,\n.transformNode select {\n  border: 1px solid #b9c7d4;\n  border-radius: 0.2rem;\n  font-size: 0.75rem;\n  min-width: 0;\n  padding: 0.23rem 0.3rem;\n  width: 100%;\n}\n.rowHandle,\n.transformHandle {\n  height: 0.72rem;\n  width: 0.72rem;\n}\n.transformNode {\n  background: #fffaf0;\n  border: 2px solid #d69127;\n  border-radius: 0.5rem;\n  box-shadow: 0 3px 12px rgb(95 67 25 / 14%);\n  display: grid;\n  gap: 0.35rem;\n  min-width: 180px;\n  padding: 0.55rem 0.65rem;\n  position: relative;\n}\n.parameterRow {\n  display: grid;\n  gap: 0.35rem;\n  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);\n}\n.parameterRowEmpty {\n  grid-template-columns: minmax(0, 0.8fr);\n}\n.transformTitle {\n  color: #82520f;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n@media (max-width: 767px) {\n  .workspace {\n    grid-template-columns: 1fr;\n    height: auto;\n    min-height: 0;\n  }\n  .ruleTree {\n    border: 1px solid #ced9e4;\n    border-radius: 0.45rem 0.45rem 0 0;\n    max-height: 200px;\n  }\n  .canvas {\n    border-radius: 0 0 0.45rem 0.45rem;\n    height: 66vh;\n    min-height: 500px;\n  }\n  .mappingBox {\n    min-width: 330px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `StructureMapFlowEditor_editor__eozFU`,
	"toolbar": `StructureMapFlowEditor_toolbar__eNRQt`,
	"workspace": `StructureMapFlowEditor_workspace__WZGHm`,
	"ruleTree": `StructureMapFlowEditor_ruleTree__rrTha`,
	"treeHeading": `StructureMapFlowEditor_treeHeading__3dKR4`,
	"treeSearch": `StructureMapFlowEditor_treeSearch__91Yy5`,
	"treeActions": `StructureMapFlowEditor_treeActions__YN9Fx`,
	"treeItem": `StructureMapFlowEditor_treeItem__MNMXm`,
	"activeTreeItem": `StructureMapFlowEditor_activeTreeItem__uM9r9`,
	"treeLabel": `StructureMapFlowEditor_treeLabel__7E81Q`,
	"treeCount": `StructureMapFlowEditor_treeCount__c20on`,
	"treeCollapseAction": `StructureMapFlowEditor_treeCollapseAction__eMZj2`,
	"canvas": `StructureMapFlowEditor_canvas__3fE4K`,
	"mappingBox": `StructureMapFlowEditor_mappingBox__CYq+i`,
	"sourceBox": `StructureMapFlowEditor_sourceBox__HA-5y`,
	"targetBox": `StructureMapFlowEditor_targetBox__rTVBQ`,
	"boxHeading": `StructureMapFlowEditor_boxHeading__CBsia`,
	"contexts": `StructureMapFlowEditor_contexts__+a4lL`,
	"empty": `StructureMapFlowEditor_empty__KnUjF`,
	"elementRow": `StructureMapFlowEditor_elementRow__D0qDQ`,
	"rowTitle": `StructureMapFlowEditor_rowTitle__Gzu0u`,
	"deleteRuleButton": `StructureMapFlowEditor_deleteRuleButton__enPHU`,
	"deleteTransformButton": `StructureMapFlowEditor_deleteTransformButton__CkEaY`,
	"rowActions": `StructureMapFlowEditor_rowActions__KUz1v`,
	"flowToggle": `StructureMapFlowEditor_flowToggle__nfzvE`,
	"transformNode": `StructureMapFlowEditor_transformNode__2FOjf`,
	"rowHandle": `StructureMapFlowEditor_rowHandle__dhmag`,
	"transformHandle": `StructureMapFlowEditor_transformHandle__Zxy6X`,
	"parameterRow": `StructureMapFlowEditor_parameterRow__gxcil`,
	"parameterRowEmpty": `StructureMapFlowEditor_parameterRowEmpty__Orbm1`,
	"transformTitle": `StructureMapFlowEditor_transformTitle__4wVxe`
};
export default ___CSS_LOADER_EXPORT___;
